export const styles = theme => ({
    teaserImage: {
        flexGrow: 1,
        width: "100%",
    },
    paper: {
      display: "flex",
      alignItems: "center",
    },
    avatar: {
      backgroundColor: "#009",
    },
    form: {
      width: "50%",
    },
    card: {
        maxWidth: 345,
        boxShadow: "0 5px 8px 0 rgba(0, 0, 0, 0.3)",
        backgroundColor: "#fafafa",
        textDecoration: "none",
        "&:hover": {
            backgroundColor: "#009",
            color: "white",
            textDecoration: "none",
        },
    },
    title: {
        "& h3": {
            margin: "1.5rem 0",
        },
        "& h4": {
            margin: "1rem 0"
        },
        margin: "2rem 0",
        "& h5": {
            margin: "0.7rem 0"
        },
        "& h6": {
            margin: "0.7rem 0"
        },
    },
    table: {
        "& allBorder": {
            border: "1px solid #ddd",
            padding: "0.7rem 0"
        },
    },
    formControl: {
        margin: "1",
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: "2",
    },
    background: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        padding: "2rem",
        margin: "2rem 0"
    },
    website: {
        // honeypot
        display: "none"
    },
    topMargin: {
        marginTop: theme.spacing(2)
    }
});
